import { useCallback, useState } from 'react';

import type { FocusedField } from '#src/app/shared/components/endorsements';

export function useEndorsementFocus() {
	const [focusedField, setFocusedField] = useState<FocusedField>(null);

	const handleFieldFocus = useCallback((field: FocusedField) => {
		setFocusedField(field);
	}, []);

	const handleFieldBlur = useCallback(() => {
		setFocusedField(null);
	}, []);

	return {
		focusedField,
		handleFieldFocus,
		handleFieldBlur,
	};
}
